<template>
  <section class="details-professional" v-if="hasProfessional">
    <div class="details-professional-itens">
      <Breadcrumb :links="links" />
      <div class="details-professional-itens-body">
        <div class="professional-header">
          <div class="professional-follow">
            <div class="professional-follow__photo">
              <img
                class="img-fluid"
                :src="getPhotoProfile"
                :alt="`foto professional ${detailProfessional.professional.name}`"
                :title="`foto professional ${detailProfessional.professional.name}`"
              />
            </div>
            <div>
              <div class="professional-information">
                <div>
                  <h2 v-if="hasCodeNameOrName">
                    {{
                      detailProfessional?.professional?.code_name ||
                      detailProfessional?.professional?.name
                    }}
                  </h2>
                  <p v-if="hasProminentProfession">
                    {{ detailProfessional.professional.prominent_profession }}
                  </p>
                </div>
              </div>
              <div v-if="hasPriceSessions" class="professional-price-session">
                <p>
                  <span>{{
                    detailProfessional.priceSessions[0].price | money
                  }}</span
                  >/sessão
                </p>
              </div>
            </div>
          </div>
          <div v-if="hasSpecialtiesHighlighted" class="professional-highlights">
            <p>Em destaque:</p>
            <div class="professional-highlights__div">
              <div
                v-for="specialtiesHighlighted in hasSpecialtiesHighlighted"
                :key="specialtiesHighlighted.id"
                class="professional-highlights__item"
              >
                {{ specialtiesHighlighted.name }}
              </div>
            </div>
          </div>
          <div class="professional-switch">
            <button
              class="professional-switch__btn"
              :class="{
                'professional-switch--valid': hasActiveServiceProfessional,
                'professional-switch--disabled': hasProfessionalServesEmployes,
              }"
              @click.prevent="handleChangeServiceProfessionalInCompany"
            >
              <p class="professional-switch__text">
                Atendimento
                <template v-if="hasActiveServiceProfessional">
                  Ativado
                </template>
                <template v-else>Desativado</template>
              </p>
              <label class="switch">
                <input
                  type="checkbox"
                  name="switch-profile"
                  :checked="hasActiveServiceProfessional"
                />
                <span class="slider round"></span>
              </label>
            </button>
            <p
              v-if="hasProfessionalServesEmployes"
              class="professional-switch__text-disabled"
            >
              Não é possível <strong>desativar</strong> o atendimento do
              profissional nessa empresa porque ele está atendendo
              colaboradores.
              <span class="block">
                Para ativar essa opção <strong>desative</strong> todos as opções
                de <strong>"Atendimento ao colaborador"</strong>.
              </span>
            </p>
          </div>
        </div>
        <div class="professional-menu">
          <div class="menu-professional">
            <div class="menu-professional-header">
              <button
                class="menu-professional-header__btn"
                :class="{
                  'menu-professional-header__btn--active':
                    companyFilterActive == 'professional-serves-employes',
                }"
                @click="companyFilterActive = 'professional-serves-employes'"
              >
                Atende esses colaboradores
              </button>
              <button
                class="menu-professional-header__btn"
                :class="{
                  'menu-professional-header__btn--active':
                    companyFilterActive == 'professional-not-serves-employes',
                }"
                @click="
                  companyFilterActive = 'professional-not-serves-employes'
                "
              >
                Não atende esses colaboradores
              </button>
            </div>
            <div
              class="row menu-professional__row"
              :class="{
                'menu-professional__row--disabled':
                  !hasActiveServiceProfessional,
              }"
            >
              <template v-if="hasCollaboratorsInCompany">
                <template v-if="getProfessionalServesEmployesInCompany.length">
                  <div
                    v-for="collaborator in getProfessionalServesEmployesInCompany"
                    :key="collaborator.id"
                    class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
                  >
                    <CardCompanyCollaborator
                      :collaborator="collaborator"
                      :enable-switch="true"
                      :professional-details="detailProfessional"
                    />
                  </div>
                </template>
                <NotData v-else :text="'Nenhum colaborador'" />
              </template>
              <NotData
                v-else
                :text="'Nenhum colaborador cadastrado nessa empresa'"
              />
            </div>
            <p
              class="text-default-disabled"
              v-if="
                !hasActiveServiceProfessional &&
                hasCollaboratorsInCompany &&
                getProfessionalServesEmployesInCompany.length
              "
            >
              Colaboradores desativados, porque é necessário ativar o
              atendimento do profissional nessa empresa, para poder alterar o
              atendimento ao colaborador.
            </p>
          </div>
        </div>
        <div class="professional-body">
          <h2>Dados sobre o profissional:</h2>
          <div v-if="hasAboutMe" class="professional-about">
            <div class="professional-about__header">
              <h2>Sobre o profissional</h2>
            </div>
            <div class="professional-about__body" v-html="contentAboutMe"></div>
          </div>
          <div v-if="hasSpecialties" class="professional-specialties">
            <div class="professional-specialties__header">
              <h2>Especialidades</h2>
            </div>
            <div class="professional-specialties__body">
              <div
                class="professional-specialties__item"
                v-for="specialties in detailProfessional.specialties"
                :key="specialties.id"
              >
                {{ specialties.name }}
              </div>
            </div>
          </div>
          <div v-if="hasFormations" class="professional-formations">
            <div class="professional-formations__header">
              <h2>Formações</h2>
            </div>
            <div class="professional-formations__body">
              <Formation
                v-for="formation in detailProfessional.formations"
                :key="formation.id"
                :formation="formation"
              />
            </div>
          </div>
          <div v-if="hasDocument" class="professional-document">
            <div class="professional-document__header">
              <h2>Registro profissional</h2>
            </div>
            <div class="professional-document__body">
              <img
                class="img-fluid"
                src="@/assets/img/icon-crp-big.png"
                alt="icon document"
                title="icon document"
              />
              <p>
                <span v-if="detailProfessional.professional.document_name"
                  >{{ detailProfessional.professional.document_name }}:</span
                >
                {{ detailProfessional.professional.document_number }}
              </p>
            </div>
          </div>
          <div class="professional-whatsapp" v-if="hasWhatsApp">
            <div class="professional-whatsapp__header">
              <h2>Número do WhatsApp</h2>
            </div>
            <div class="professional-whatsapp__body">
              <button
                class="professional-whatsapp__btn"
                @click="
                  sendWhatsAppProfessional(
                    detailProfessional.professional.number_whats_app
                  )
                "
              >
                <img
                  class="img-fluid"
                  src="@/assets/img/whatsapp-original.png"
                  alt="icon whatsapp"
                  title="icon whatsapp"
                />
                <p>
                  {{ detailProfessional.professional.number_whats_app }}
                </p>
              </button>
            </div>
          </div>
          <div v-if="hasPriceSessions" class="professional-prices">
            <div class="professional-prices__header">
              <h2>Valores</h2>
            </div>
            <div class="professional-prices__body">
              <Price
                v-for="price in detailProfessional.priceSessions"
                :key="price.id"
                :price="price"
              />
            </div>
          </div>
          <div v-if="hasMethodsPayment" class="professional-method-payment">
            <div class="professional-method-payment__header">
              <h2>Métodos de pagamento</h2>
            </div>
            <div class="professional-method-payment__body">
              <BtnMethodPayment
                v-for="methodPayment in detailProfessional.methodsPayment"
                :key="methodPayment.id"
                :method-payment="methodPayment"
              />
            </div>
          </div>
          <div v-if="hasDaysOfTheWeekAndSchedule" class="professional-schedule">
            <div class="professional-schedule__header">
              <h2>Jornada de trabalho</h2>
            </div>
            <div class="professional-schedule__body">
              <BtnDaysWork
                v-for="day in detailProfessional.daysOfTheWeek"
                :key="day.id"
                :day-of-the-week="day"
                :active="true"
              />
            </div>
            <h3 class="professional-schedule__hours">
              <div class="icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1805_2495)">
                    <path
                      d="M9 17.4375C7.33122 17.4375 5.69992 16.9427 4.31238 16.0155C2.92484 15.0884 1.84338 13.7706 1.20477 12.2289C0.566156 10.6871 0.399065 8.99064 0.724628 7.35393C1.05019 5.71721 1.85378 4.2138 3.03379 3.03379C4.2138 1.85378 5.71721 1.05019 7.35393 0.724628C8.99064 0.399065 10.6871 0.566156 12.2289 1.20477C13.7706 1.84338 15.0884 2.92484 16.0155 4.31238C16.9427 5.69992 17.4375 7.33122 17.4375 9C17.4375 11.2378 16.5486 13.3839 14.9662 14.9662C13.3839 16.5486 11.2378 17.4375 9 17.4375ZM9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86545 2.24413 6.20163C1.69067 7.53782 1.54586 9.00812 1.82801 10.4266C2.11017 11.8451 2.80661 13.1481 3.82929 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4542 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3125 7.06061 15.5421 5.20065 14.1707 3.82929C12.7994 2.45793 10.9394 1.6875 9 1.6875Z"
                      fill="#707070"
                    />
                    <path
                      d="M11.385 12.1837L8.60063 9.39937C8.5485 9.34681 8.50726 9.28448 8.47926 9.21595C8.45127 9.14741 8.43708 9.07403 8.43751 9V4.5H9.56251V8.76938L12.1838 11.385L11.385 12.1837Z"
                      fill="#707070"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1805_2495">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              De:
              {{ detailProfessional.schedule.service_start_time | timeFormat }}
              ás
              {{ detailProfessional.schedule.service_end_time | timeFormat }}
            </h3>
            <h4 class="professional-schedule__hours">
              <div class="icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1805_2495)">
                    <path
                      d="M9 17.4375C7.33122 17.4375 5.69992 16.9427 4.31238 16.0155C2.92484 15.0884 1.84338 13.7706 1.20477 12.2289C0.566156 10.6871 0.399065 8.99064 0.724628 7.35393C1.05019 5.71721 1.85378 4.2138 3.03379 3.03379C4.2138 1.85378 5.71721 1.05019 7.35393 0.724628C8.99064 0.399065 10.6871 0.566156 12.2289 1.20477C13.7706 1.84338 15.0884 2.92484 16.0155 4.31238C16.9427 5.69992 17.4375 7.33122 17.4375 9C17.4375 11.2378 16.5486 13.3839 14.9662 14.9662C13.3839 16.5486 11.2378 17.4375 9 17.4375ZM9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86545 2.24413 6.20163C1.69067 7.53782 1.54586 9.00812 1.82801 10.4266C2.11017 11.8451 2.80661 13.1481 3.82929 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4542 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3125 7.06061 15.5421 5.20065 14.1707 3.82929C12.7994 2.45793 10.9394 1.6875 9 1.6875Z"
                      fill="#707070"
                    />
                    <path
                      d="M11.385 12.1837L8.60063 9.39937C8.5485 9.34681 8.50726 9.28448 8.47926 9.21595C8.45127 9.14741 8.43708 9.07403 8.43751 9V4.5H9.56251V8.76938L12.1838 11.385L11.385 12.1837Z"
                      fill="#707070"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1805_2495">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              Tempo de consulta:
              {{ detailProfessional.schedule.service_slot_time | timeFormat }}
            </h4>
            <div class="professional-schedule__google-calendar">
              <h5 class="subtitle">Agenda do Google calendar</h5>
              <a
                class="btn-google-calendar external"
                :href="detailProfessional.schedule.url_google_calendar"
              >
                <p>Google calendar</p>
                <svg
                  height="48px"
                  viewBox="0 0 48 48"
                  width="48px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect fill="#fff" height="22" width="22" x="13" y="13" />
                  <polygon
                    fill="#1e88e5"
                    points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616"
                  />
                  <path
                    d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z"
                    fill="#1e88e5"
                  />
                  <polygon
                    fill="#fbc02d"
                    points="34,42 14,42 13,38 14,34 34,34 35,38"
                  />
                  <polygon
                    fill="#4caf50"
                    points="38,35 42,34 42,14 38,13 34,14 34,34"
                  />
                  <path
                    d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z"
                    fill="#1e88e5"
                  />
                  <polygon fill="#e53935" points="34,34 34,42 42,34" />
                  <path
                    d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z"
                    fill="#1565c0"
                  />
                  <path
                    d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z"
                    fill="#1565c0"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div v-if="hasTargetAudience" class="professional-target-audience">
            <div class="professional-target-audience__header">
              <h2>Público alvo do profissional</h2>
            </div>
            <div class="professional-target-audience__body">
              <div
                class="professional-target-audience__item"
                v-for="targetAudience in detailProfessional.targetAudience"
                :key="targetAudience.id"
              >
                {{ targetAudience.name }}
              </div>
            </div>
          </div>
          <div v-if="false" class="professional-reviews">
            <div class="professional-reviews__header">
              <h2>Avaliações</h2>
            </div>
            <div class="professional-reviews__body">
              <swiper :options="swiperReviews">
                <swiper-slide v-for="review in arrayReviews" :key="review.id">
                  <Review :review="review" />
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";
import Formation from "@/views/Professional/components/Formation";
import Price from "@/views/Professional/components/Price";
import BtnDaysWork from "@/views/Professional/components/BtnDaysWork";
import DOMPurify from "dompurify";
import BtnMethodPayment from "@/views/Professional/components/BtnMethodPayment";
import CardCompanyCollaborator from "@/views/Company/components/CardCompanyCollaborator";
import NotData from "@/components/notData/Index";

export default {
  components: {
    Breadcrumb,
    Formation,
    Price,
    BtnDaysWork,
    BtnMethodPayment,
    CardCompanyCollaborator,
    NotData,
  },
  computed: {
    ...mapGetters({ detailProfessional: "Company/companyProfessionalDetails" }),
    hasProfessional() {
      return (
        this.detailProfessional &&
        typeof this.detailProfessional === "object" &&
        Object.keys(this.detailProfessional).length > 0
      );
    },
    hasCodeNameOrName() {
      return (
        this.hasProfessional &&
        (this.detailProfessional?.professional?.code_name ||
          this.detailProfessional?.professional?.name)
      );
    },
    hasProminentProfession() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.professional?.prominent_profession
      );
    },
    hasAboutMe() {
      return (
        this.hasProfessional && this.detailProfessional?.professional?.about_me
      );
    },
    hasSpecialties() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.specialties &&
        Array.isArray(this.detailProfessional.specialties) &&
        this.detailProfessional.specialties.length > 0
      );
    },
    hasSpecialtiesHighlighted() {
      if (this.hasProfessional && this.hasSpecialties) {
        const specialtiesHighlighted =
          this.detailProfessional.specialties.filter(
            (item) => item.is_highlighted
          );

        return specialtiesHighlighted.length > 0
          ? specialtiesHighlighted
          : false;
      }

      return false;
    },
    hasFormations() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.formations &&
        Array.isArray(this.detailProfessional.formations) &&
        this.detailProfessional.formations.length > 0
      );
    },
    hasDocument() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.professional?.document_number
      );
    },
    hasWhatsApp() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.professional?.number_whats_app
      );
    },
    hasPriceSessions() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.priceSessions &&
        Array.isArray(this.detailProfessional.priceSessions) &&
        this.detailProfessional.priceSessions.length > 0
      );
    },
    hasDaysOfTheWeek() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.daysOfTheWeek &&
        Array.isArray(this.detailProfessional.daysOfTheWeek) &&
        this.detailProfessional.daysOfTheWeek.length > 0
      );
    },
    hasSchedule() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.schedule &&
        typeof this.detailProfessional.schedule === "object" &&
        Object.keys(this.detailProfessional.schedule).length > 0
      );
    },
    hasDaysOfTheWeekAndSchedule() {
      return this.hasDaysOfTheWeek && this.hasSchedule;
    },
    hasCompany() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.hasCompany &&
        Object.keys(this.detailProfessional.hasCompany).length
      );
    },
    hasActiveServiceProfessional() {
      if (!this.hasCompany) {
        return false;
      }

      const hasCompany = this.detailProfessional.hasCompany;

      const isActive =
        hasCompany.id_company === this.$route.params.id &&
        hasCompany.id_professional === this.$route.params.idProfessional &&
        hasCompany.is_active;
      return this.hasProfessional && isActive;
    },
    getPhotoProfile() {
      return (
        (this.detailProfessional?.professional?.profile_photo_file_path ??
          this.detailProfessional?.professional?.photo_url) ||
        require("@/assets/img/image-user-google.png")
      );
    },
    contentAboutMe() {
      return DOMPurify.sanitize(
        this.detailProfessional?.professional.about_me || ""
      );
    },
    hasMethodsPayment() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.methodsPayment &&
        Array.isArray(this.detailProfessional.methodsPayment) &&
        this.detailProfessional.methodsPayment.length > 0
      );
    },
    hasTargetAudience() {
      return (
        this.hasProfessional &&
        this.detailProfessional?.targetAudience &&
        Array.isArray(this.detailProfessional.targetAudience) &&
        this.detailProfessional.targetAudience.length > 0
      );
    },
    hasCollaboratorsInCompany() {
      return (
        Object.keys(this.detailProfessional?.companyCollaborators).length &&
        (this.detailProfessional?.companyCollaborators?.service.length ||
          this.detailProfessional?.companyCollaborators?.notService.length)
      );
    },
    hasProfessionalServesEmployes() {
      return this.professionalServesEmployes.length;
    },
    professionalServesEmployes() {
      return this.detailProfessional?.companyCollaborators.service;
    },
    professionalNotServesEmployes() {
      return this.detailProfessional?.companyCollaborators.notService;
    },
    getProfessionalServesEmployesInCompany() {
      return this.companyFilterActive === "professional-serves-employes"
        ? this.professionalServesEmployes
        : this.professionalNotServesEmployes;
    },
  },
  data() {
    return {
      isActiveProfessionalCompanyService: false,
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Profissionais",
          routerName: "ListProfessionalsCompany",
        },
        {
          name: "Registrar",
          routerName: "RegisterProfessionalCompany",
        },
      ],
      companyFilterActive: "professional-serves-employes",
    };
  },
  async mounted() {
    const payload = {
      id: this.$route.params.id,
      idProfessional: this.$route.params.idProfessional,
    };
    await this.consultCompanyProfessionalDetails(payload);

    this.handleDataBreadcrumb();
  },
  methods: {
    ...mapActions("Company", [
      "updateCompanyProfessional",
      "consultCompanyProfessionalDetails",
    ]),
    sendDialogDefault(type, message, showBtns = true, showTimer = false) {
      let objFire = {
        html: message,
        icon: type,
        showConfirmButton: showBtns,
        showCancelButton: showBtns,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#EF0000",
        confirmButtonText: "SIM",
        cancelButtonText: "NÃO",
      };

      if (showTimer) {
        objFire = {
          ...objFire,
          timer: 3000,
          timerProgressBar: true,
        };
      }

      return this.$swal.fire(objFire);
    },
    async handleChangeServiceProfessionalInCompany() {
      this.isActiveProfessionalCompanyService =
        !this.hasActiveServiceProfessional;

      const statusMessage = this.isActiveProfessionalCompanyService
        ? "Ativar"
        : "Desativar";
      const color = `var(${
        this.isActiveProfessionalCompanyService ? "--green" : "--red-2"
      })`;
      const codeNameOrName =
        this.detailProfessional.professional.code_name ||
        this.detailProfessional.professional.name;
      const messageDialog = `Tem certeza que deseja <b style="color: ${color};">${statusMessage}</b> o atendimento do profissional
       <b style="font-size: 20px; color: ${color};">${codeNameOrName}</b> na empresa <b style="color: ${color};">${this.$route.params.slug}?</b>`;

      const dataDialog = await this.sendDialogDefault("warning", messageDialog);

      if (!dataDialog?.isConfirmed) return;

      const objCompanyHasProfessional = {
        id_company: this.$route.params.id,
        id_professional: this.detailProfessional.professional.id,
        is_active: this.isActiveProfessionalCompanyService,
      };

      if (this.hasCompany) {
        objCompanyHasProfessional.id = this.detailProfessional.hasCompany.id;
      }

      await this.updateCompanyProfessional(objCompanyHasProfessional);

      const payload = {
        id: this.$route.params.id,
        idProfessional: this.$route.params.idProfessional,
      };
      await this.consultCompanyProfessionalDetails(payload);

      const textMessage = this.hasActiveServiceProfessional
        ? "Ativado"
        : "Desativado";
      const message = `O atendimento do profissional <b style="font-size: 20px; color:${color};">${codeNameOrName}</b> na empresa <b style="font-size: 20px; color:${color};">${this.$route.params.slug}</b> foi <b style="color: ${color};">${textMessage}</b>.`;
      const showBtns = false;
      const showTimer = true;

      this.sendDialogDefault("success", message, showBtns, showTimer);
    },
    sendWhatsAppProfessional(number) {
      const regexNumber = /[()\s-]/g;
      const numberFormatted = `55${number.replace(regexNumber, "")}`;
      const codeNameOrName =
        this.detailProfessional.professional.code_name ??
        this.detailProfessional.professional.name;

      const message = `Olá, ${codeNameOrName}, encontrei seu perfil no Evolution e gostaria de tirar algumas dúvidas:`;
      const encodedMessage = encodeURIComponent(message);
      const urlApiWhatsApp = "https://api.whatsapp.com/send?";

      window.open(
        `${urlApiWhatsApp}phone=${numberFormatted}&text=${encodedMessage}`,
        "_blank",
        "noopener"
      );
    },
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
      this.links[3].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
      this.links[4].name =
        this.detailProfessional?.professional?.code_name ||
        this.detailProfessional?.professional?.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.details-professional {
  text-align: left;
  &-itens {
    &-body {
      position: relative;
      @media (max-width: 991px) {
        padding-top: 50px;
      }
      h2 {
        font-size: 24px;
        font-family: "Font Semibold";
        color: var(--black);
        text-align: left;
        margin-bottom: 30px;
      }
    }
  }
}
.professional {
  &-switch {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    @media (max-width: 991px) {
      top: 0;
      right: 0;
    }
    &__btn {
      padding: 20px 15px;
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--white);
      border-radius: 10px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      border: 1px solid var(--red-medium);
      @media (max-width: 991px) {
        padding: 10px 15px;
      }
    }
    &__text {
      font-size: 14px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 0;
      &-disabled {
        font-size: 10px;
        font-family: "Font Light";
        color: var(--black);
        text-align: right;
        margin-top: 5px;
        margin-bottom: 0;
        span {
          display: block;
        }
      }
    }
    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 51px;
      height: 26px;
      margin-bottom: 0;
    }
    /* Hide default HTML checkbox */
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }
    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--red-dark);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
    .slider:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 3px;
      bottom: 3px;
      background-color: var(--white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
    input:checked + .slider {
      background-color: var(--green);
    }
    input:checked + .slider:before {
      -webkit-transform: translateX(25px);
      -ms-transform: translateX(25px);
      transform: translateX(25px);
    }
    /* Rounded sliders */
    .slider.round {
      border-radius: 20px;
    }
    .slider.round:before {
      border-radius: 100%;
    }
    &--valid {
      border-color: var(--green);
    }
  }
  &-header {
    padding: 30px 0;
    border-bottom: 1px solid var(--gray-medium);
  }
  &-follow {
    display: flex;
    align-items: center;
    gap: 20px;
    max-width: 360px;
    &__photo {
      img {
        max-width: 80px;
        max-height: 80px;
        object-fit: cover;
        border-radius: 100%;
      }
    }
    &__profile {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 120px);
      gap: 20px;
      p {
        font-size: 20px;
        font-family: "Font Semibold";
        color: var(--green-2);
        text-align: center;
        line-height: 1;
        margin-bottom: 0;
        span {
          display: block;
          font-size: 10px;
          font-family: "Font Regular";
          color: var(--black);
        }
      }
    }
  }
  &-information {
    display: flex;
    align-items: flex-start;
    text-align: left;
    gap: 10px;
    margin-bottom: 10px;
    h2 {
      font-size: 16px;
      font-family: "Font Semibold";
      color: var(--black);
      text-transform: capitalize;
      margin-bottom: 0;
    }
    p {
      font-size: 12px;
      font-family: "Font Light Italic";
      color: var(--green-super-dark);
      margin-bottom: 0;
    }
  }
  &-price-session {
    display: flex;
    align-items: center;
    gap: 10px;
    p {
      font-size: 10px;
      font-family: "Font Regular";
      color: var(--black);
      line-height: 1;
      margin-bottom: 0;
      span {
        font-size: 16px;
        font-family: "Font Bold";
        color: var(--black);
      }
    }
    .btn-view-all-prices {
      display: flex;
      width: initial;
      font-size: 14px;
      font-family: "Font Light";
      color: var(--gray-dark);
      margin-bottom: 0;
      border: 0;
      border-bottom: 1px solid var(--gray-dark);
      background: 0;
      padding: 0;
      line-height: 1;
    }
  }
  &-highlights {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    p {
      font-size: 12px;
      font-family: "Font Light";
      color: var(--gray-dark);
      margin-bottom: 0;
    }
    &__div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    &__item {
      padding: 3px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--white);
      border: 1px solid var(--blue);
      border-radius: 30px;
      font-size: 12px;
      font-family: "Font Light";
      color: var(--black);
    }
  }
  &-body {
    padding: 15px 0 50px 0;
  }
  &-specialties {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;
    }
    &__item {
      padding: 5px 20px;
      background: var(--white);
      border: 1px solid var(--green);
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-family: "Font Regular";
      color: var(--black);
    }
  }
  &-formations {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
  }
  &-document,
  &-whatsapp {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
        span {
          display: block;
          font-size: 10px;
          font-family: "Font Light";
          color: var(--gray-dark);
        }
      }
    }
    &__body {
      display: flex;
      align-items: center;
      gap: 10px;
      img {
        max-width: 24px;
      }
      p {
        font-size: 14px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
        span {
          font-family: "Font Regular";
        }
      }
    }
  }
  &-whatsapp {
    &__btn {
      width: 100%;
      max-width: 200px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #25d366;
      border: 0;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      transition: 500ms;
      p {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--white);
        margin-bottom: 0;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &-prices {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
  }
  &-method-payment {
    padding: 15px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-weight: 600;
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: 15px;
      @media (min-width: 768px) {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 20px;
      }
      @media (min-width: 992px) {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 20px;
      }
    }
  }
  &-about {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      font-size: 14px;
      font-family: "Font Regular";
      color: var(--gray-dark);
      p {
        margin-bottom: 15px;
      }
    }
  }
  &-reviews {
    padding: 20px 0;
    &__header {
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      position: relative;
      padding-bottom: 30px;
      margin-bottom: 30px;
      .swiper-pagination {
        bottom: 0;
        width: 100%;
        &:deep(.swiper-pagination-bullet) {
          width: 10px;
          height: 10px;
          background: var(--gray-1);
          margin: 0px 4px;
          opacity: 0.6;
          box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        }
        &:deep(.swiper-pagination-bullet-active) {
          background-color: var(--main-color-light);
          opacity: 1;
        }
      }
    }
  }
  &-schedule {
    padding: 20px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
        span {
          display: block;
          font-size: 10px;
          font-family: "Font Light";
          color: var(--gray-dark);
        }
      }
    }
    &__body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }
    &__hours {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--gray-dark);
      margin-top: 15px;
      margin-bottom: 0;
      .icon {
        display: flex;
        align-items: center;
        margin-right: 5px;
      }
    }
    &__google-calendar {
      padding: 40px 0 0 0;
      .subtitle {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
      .btn-google-calendar {
        width: 100%;
        max-width: 200px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: var(--white);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 30px;
        margin-top: 15px;
        svg {
          max-width: 28px;
        }
        p {
          font-size: 16px;
          font-family: "Font Light";
          color: var(--black);
          margin-bottom: 0;
        }
      }
    }
  }
  &-target-audience {
    padding: 15px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-weight: 600;
        color: var(--black);
        margin-bottom: 0;
      }
    }
    &__body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;
    }
    &__item {
      padding: 5px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--blue);
      border: 1px solid var(--blue);
      border-radius: 30px;
      font-size: 12px;
      font-family: "Font Bold";
      color: var(--white);
    }
  }
  &-menu {
    padding: 50px 0;
    .menu-professional {
      &-header {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 30px;
        &__btn {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
          background: 0;
          border: 0;
          border-bottom: 2px solid transparent;
          font-size: 20px;
          font-family: "Font Light";
          color: var(--black);
          @media (max-width: 991px) {
            font-size: 14px;
          }
          &--active {
            font-family: "Font Semibold";
            font-size: 24px;
            border-color: var(--green);
            @media (max-width: 991px) {
              font-size: 16px;
            }
          }
        }
      }
      &__row {
        row-gap: 30px;
        &:deep(.data-not-filled) {
          margin: 0 15px;
        }
        &--disabled {
          &:deep(.card-company-plan) {
            pointer-events: none;
            opacity: 0.5;
          }
        }
      }
    }
  }
}
.text-default-disabled {
  font-size: 16px;
  font-family: "Font Light";
  color: var(--red-dark);
  text-align: left;
  margin-top: 5px;
  margin-bottom: 0;
  span {
    display: block;
  }
}
</style>
